// extracted by mini-css-extract-plugin
export default {"table-area":"Table_table-area__8xkbL","target-table":"Table_target-table__ehamO","main-ul":"Table_main-ul__3uBUo","sub-ul":"Table_sub-ul__X9UsX"};